import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }
        setLoading(true);
        try {
            await register(email, password, name);
            toast.success("Account created — 1 free credit added.");
            navigate("/dashboard");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Registration failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="register-page">
            <div className="surface p-8 w-full max-w-md">
                <div className="flex items-center gap-2 mb-6">
                    <Sparkles className="w-4 h-4 text-accent" />
                    <span className="overline !text-zinc-400">Get started</span>
                </div>
                <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Create account</h1>
                <p className="text-sm text-zinc-500 mb-8">1 free listing on us. No card required.</p>

                <form onSubmit={submit} method="post" className="space-y-5" autoComplete="on">
                    <div>
                        <label htmlFor="register-name" className="block text-xs font-medium text-zinc-400 mb-2">Name</label>
                        <input
                            id="register-name"
                            name="name"
                            type="text"
                            autoComplete="name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="surface-input"
                            data-testid="register-name"
                            placeholder="Alex Seller"
                        />
                    </div>
                    <div>
                        <label htmlFor="register-email" className="block text-xs font-medium text-zinc-400 mb-2">Email</label>
                        <input
                            id="register-email"
                            name="email"
                            type="email"
                            autoComplete="username"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="surface-input"
                            data-testid="register-email"
                            placeholder="seller@store.com"
                        />
                    </div>
                    <div>
                        <label htmlFor="register-password" className="block text-xs font-medium text-zinc-400 mb-2">Password</label>
                        <input
                            id="register-password"
                            name="password"
                            type="password"
                            autoComplete="new-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="surface-input"
                            data-testid="register-password"
                            placeholder="At least 6 characters"
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit">
                        {loading ? "Creating..." : "Create account"}
                    </button>
                </form>
                <p className="mt-6 text-sm text-zinc-500">
                    Already have an account? <Link to="/login" className="text-accent hover:underline" data-testid="register-login-link">Sign in</Link>
                </p>
            </div>
        </div>
    );
}
